function jobsSelector(state: sage.state.IRedux): sage.model.IJob[] | undefined {
    return state.jobs.jobs;
}

export default jobsSelector;
